import { createStyles } from '@material-ui/core';
export var styles = function (theme) {
    return createStyles({
        root: {
            minWidth: '272px',
            '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                transform: 'none',
            },
            '& .MuiFormLabel-root': {
                position: 'relative',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
                color: theme.palette.text.secondary,
                '&:not(.Mui-error).Mui-focused': {
                    color: theme.palette.common.black,
                },
            },
            '& .Mui-error': {
                '& fieldset': {
                    opacity: 'unset',
                    boxShadow: 'none',
                },
            },
            '& .MuiOutlinedInput-root': {
                color: theme.palette.text.primary,
                background: theme.palette.common.white,
                borderRadius: '8px',
                '& fieldset': {
                    borderColor: theme.palette.custom.border,
                },
                '&.Mui-disabled': {
                    '& fieldset': {
                        borderColor: theme.palette.custom.border,
                    },
                },
                '&:not(.Mui-error):hover': {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.custom.border,
                    },
                },
            },
            '& :focus-within': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: '1px',
                    borderColor: theme.palette.custom.border,
                },
                '& fieldset': {
                    borderWidth: '1px',
                    boxShadow: "0px 0px 8px " + theme.palette.primary.main,
                },
            },
            '& input:disabled, .MuiFormLabel-root.Mui-disabled': {
                color: theme.palette.text.disabled,
            },
            '& input:disabled+label': {
                color: theme.palette.text.disabled,
            },
            '& input[type="time"] + fieldset legend': {
                fontSize: theme.spacing(2),
                fontWeight: '400',
                lineHeight: '48px',
                visibility: 'visible',
                whiteSpace: 'nowrap',
                color: theme.palette.custom.disabledInputsPlaceholder,
            },
            '& input[type="time"]:focus-within + fieldset legend': {
                visibility: 'hidden',
            },
            '& input[type="time"]:disabled + fieldset legend': {
                visibility: 'hidden',
            },
        },
    });
};
